"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarePortal = void 0;
const helper_1 = require("../../helper");
class CarePortal {
    constructor() { }
    /**********************************************************************************************************************
     *                     START : Care Portal Software Parser
     * ********************************************************************************************************************/
    /**
     * @function CarePortalSoftwareParser
     * @param pastedData
     * @param event
     * @param callbackEmit
     * @summary CarePortalSoftwareParser Software Parser @pastedData string break by session to session
     * @returns {callback}
     */
    parse(pastedData, event, callbackEmit) {
        /**Default Value*/
        this.fromPDF = false;
        //Identify Copy from data
        if (pastedData.indexOf("Patient Demographics for") != -1 &&
            pastedData.indexOf("Printed :") != -1) {
            /**Copy From PDF*/
            this.fromPDF = true;
        }
        else {
            /**Copy From WEBSITE*/
            this.fromPDF = false;
        }
        try {
            let sendCallBackData;
            if (this.fromPDF) {
                sendCallBackData = this.copyPastedFromPDF(pastedData);
            }
            else {
                sendCallBackData = this.copyPastedFromWebsite(pastedData);
            }
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    /**
     * @function copyPastedFromWebsite
     * @param pastedData
     * @returns {Object}
     * @summary If user copy pasted data from kantime website
     */
    copyPastedFromWebsite(pastedData) {
        //**Session 1 Patient name*/
        const sessionFirst = (0, helper_1.substrInBetween)(pastedData, "Title:", "General Patient Information");
        //**Patient Information*/
        const patientInfo = this.gettingPatientDetails(sessionFirst);
        return Object.assign({}, patientInfo);
    }
    /**
     * @function copyPastedFromPDF
     * @param pastedData
     * @returns {Object}
     * @summary If user copy pasted data from PDF
     */
    copyPastedFromPDF(pastedData) {
        //**Session 1 Patient name*/
        const sessionFirstPre = (0, helper_1.substrInBetween)(pastedData, "Patient Demographics Directions", "E-Mail Address");
        //**Patient Information*/
        const patientInfo = this.gettingPatientDetails(sessionFirstPre);
        return Object.assign({}, patientInfo);
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from kantime
     */
    gettingPatientDetails(sessionFirst) {
        if (!sessionFirst) {
            return {};
        }
        //Only for website case
        // if (this.fromPDF == false) {
        //   sessionFirst = sessionFirst.substr(0, sessionFirst.indexOf('Age:'));
        // }
        let dob = (0, helper_1.substrInBetween)(sessionFirst, this.fromPDF ? "Date of Birth" : "Date of Birth:", "Unknown");
        if (dob) {
            dob = (0, helper_1.trim)(dob);
        }
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(sessionFirst.substr(0, sessionFirst.indexOf("Gender")))), this.patientPhoneNumberWithAddress(sessionFirst)), { email: (0, helper_1.getEmailAddress)((0, helper_1.substrInBetween)(sessionFirst, "Email:", "DL NO:")), dob: (0, helper_1.getDOB)(dob, this.fromPDF) }),
        };
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
                apartmentNo: "",
            },
        };
        //**Note: From PDF */
        if (this.fromPDF) {
            const pAddress = (0, helper_1.substrInBetween)(firstSession, "Address1", "Address2");
            const completeAddress = pAddress + (0, helper_1.substrInBetween)(firstSession, "*City/ State/ Zip", "City");
            //number
            const phoneNumbers = (0, helper_1.substrInBetween)(firstSession, "Telephone", "Cellular Number");
            const numbers = phoneNumbers.split(" ");
            //address
            if (completeAddress) {
                info.address.placeName = (0, helper_1.trim)(completeAddress);
            }
            // const numbers = phoneNumbers(pNumber);
            if (numbers[0] && (0, helper_1.arrayLength)(numbers[0])) {
                const firstNumber = (numbers[0] ? numbers[0] : "").replace(/[\s-()]/g, "");
                info.phoneNo = (0, helper_1.changeNumberUSFormat)(firstNumber);
            }
        }
        else {
            //**Note: From WEBSITE */
            const pAddress = (0, helper_1.substrInBetween)(firstSession, "Address1:", "Address2:");
            const completeAddress = pAddress + (0, helper_1.substrInBetween)(firstSession, "*City/ State/ Zip:", "City:");
            //address
            if (completeAddress) {
                info.address.placeName = (0, helper_1.trim)(completeAddress);
            }
            //number
            const numbers = (0, helper_1.substrInBetween)(firstSession, "Telephone:", "Cellular Number:");
            if (numbers && (0, helper_1.arrayLength)(numbers)) {
                const firstNumber = (numbers ? numbers : "").replace(/[\s-()]/g, "");
                info.phoneNo = (0, helper_1.changeNumberUSFormat)(firstNumber);
            }
        }
        //@Return address or phoneNo
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        const name = {
            firstName: "",
            lastName: "",
        };
        //**Note: From PDF */
        if (this.fromPDF) {
            const patientFirstName = sessionFirst.substring(sessionFirst.indexOf("Name") + 5, sessionFirst.indexOf("Middle"));
            //Value trim
            if (patientFirstName) {
                name.firstName = (0, helper_1.trim)(patientFirstName);
            }
            const patientLastName = (0, helper_1.substrInBetween)(sessionFirst, "Last Name", "Suffix");
            if (patientLastName) {
                name.lastName = (0, helper_1.trim)(patientLastName);
            }
            let suffix = (0, helper_1.substrInBetween)(sessionFirst, "Suffix:", "(M0064)");
            if (suffix) {
                suffix = (0, helper_1.trim)(suffix);
                name.firstName = `${suffix} ${name.firstName}`;
            }
        }
        else {
            //**Note: From WEBSITE */
            const patientFirstName = sessionFirst.substring(sessionFirst.indexOf("Name:") + 5, sessionFirst.indexOf("Middle"));
            //Value trim
            if (patientFirstName) {
                name.firstName = (0, helper_1.trim)(patientFirstName);
            }
            const patientLastName = sessionFirst.substring(sessionFirst.indexOf("Last Name:") + 10, sessionFirst.indexOf("Suffix:"));
            if (patientLastName) {
                name.lastName = (0, helper_1.trim)(patientLastName);
            }
            let suffix = (0, helper_1.substrInBetween)(sessionFirst, "Suffix:", "(M0064)");
            if (suffix) {
                suffix = (0, helper_1.trim)(suffix);
                name.firstName = `${suffix}. ${name.firstName}`;
            }
        }
        //@Return name
        return name;
    }
}
exports.CarePortal = CarePortal;
